


document.addEventListener("DOMContentLoaded", function () {
  // Local Countdown Timer
  const timerElement = document.querySelector('countdown-timer');
  if (timerElement) {
    const schemaTime = timerElement.getAttribute('schema-time');
    if (schemaTime) {
      let countDownDate = new Date(schemaTime).getTime() + 60 * 1000; // Add 60 seconds

      const countdown = document.querySelector('.countdown');
      if (countdown) {
        const daysContainer = countdown.querySelector('.js-days span');
        const hoursContainer = countdown.querySelector('.js-hours span');
        const minutesContainer = countdown.querySelector('.js-minutes span');
        const timeUpMessage = countdown.querySelector('.time-up-message');

        if (daysContainer && hoursContainer && minutesContainer && timeUpMessage) {
          const startCountdown = () => {
            const timer = setInterval(function () {
              let now = new Date().getTime();
              let distance = countDownDate - now;

              if (distance < 0) {
                clearInterval(timer);
                timeUpMessage.innerHTML = "Time's Up!";
                return;
              }

              let days = Math.floor(distance / (1000 * 60 * 60 * 24));
              let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

              daysContainer.innerHTML = days;
              hoursContainer.innerHTML = hours;
              minutesContainer.innerHTML = minutes;
            }, 1000);
          };

          startCountdown();
        } else {

        }
      } else {

      }
    } else {
  
    }
  } else {

  }

  // Global Countdown Timer
  // const globalTimerElement = document.querySelector('global-countdown-timer');
  // if (globalTimerElement) {
  //   const globalSchemaTime = globalTimerElement.getAttribute('global-schema-time');
  //   if (globalSchemaTime) {
  //     let globalCountDownDate = new Date(globalSchemaTime).getTime() + 60 * 1000; // Add 60 seconds

  //     const globalCountdown = document.querySelector('.global-countdown');
  //     if (globalCountdown) {
  //       const globalDaysContainer = globalCountdown.querySelector('.gb-js-days span');
  //       const globalHoursContainer = globalCountdown.querySelector('.gb-js-hours span');
  //       const globalMinutesContainer = globalCountdown.querySelector('.gb-js-minutes span');
  //       const globalTimeUpMessage = globalCountdown.querySelector('.time-up-message');

  //       if (globalDaysContainer && globalHoursContainer && globalMinutesContainer && globalTimeUpMessage) {
  //         const startGlobalCountdown = () => {
  //           const globalTimer = setInterval(function () {
  //             let now = new Date().getTime();
  //             let distance = globalCountDownDate - now;

  //             if (distance < 0) {
  //               clearInterval(globalTimer);
  //               globalTimeUpMessage.innerHTML = "Time's Up!";
  //               return;
  //             }

  //             let days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //             let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //             let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

  //             globalDaysContainer.innerHTML = days;
  //             globalHoursContainer.innerHTML = hours;
  //             globalMinutesContainer.innerHTML = minutes;
  //           }, 1000);
  //         };

  //         startGlobalCountdown();
  //       } else {

  //       }
  //     } else {

  //     }
  //   } else {

  //   }
  // } else {

  // }

  // timer multipale timer show on the one page 

  document.querySelectorAll('global-countdown-timer').forEach((timerElement) => {
    const globalSchemaTime = timerElement.getAttribute('global-schema-time');
    if (globalSchemaTime) {
      let globalCountDownDate = new Date(globalSchemaTime).getTime() + 60 * 1000; // Add 60 seconds
  
      const globalCountdown = timerElement.querySelector('.global-countdown');
      if (globalCountdown) {
        const globalDaysContainer = globalCountdown.querySelector('.gb-js-days span');
        const globalHoursContainer = globalCountdown.querySelector('.gb-js-hours span');
        const globalMinutesContainer = globalCountdown.querySelector('.gb-js-minutes span');
        const globalTimeUpMessage = globalCountdown.querySelector('.time-up-message');
  
        if (globalDaysContainer && globalHoursContainer && globalMinutesContainer && globalTimeUpMessage) {
          const startGlobalCountdown = () => {
            const globalTimer = setInterval(function () {
              let now = new Date().getTime();
              let distance = globalCountDownDate - now;
  
              if (distance < 0) {
                clearInterval(globalTimer);
                globalTimeUpMessage.innerHTML = "Time's Up!";
                return;
              }
  
              let days = Math.floor(distance / (1000 * 60 * 60 * 24));
              let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  
              globalDaysContainer.innerHTML = days;
              globalHoursContainer.innerHTML = hours;
              globalMinutesContainer.innerHTML = minutes;
            }, 1000);
          };
  
          startGlobalCountdown();
        }
      }
    }
  });
  
});
